/** Change Log filter options (match audit_logs writers in API). */

export const CHANGELOG_ACTION_OPTIONS = [
  { value: 'update', label: 'Update' },
  { value: 'replace', label: 'Replace' },
  { value: 'create', label: 'Create' },
  { value: 'delete', label: 'Delete' },
  { value: 'soft_delete', label: 'Soft delete' },
  { value: 'restore', label: 'Restore' },
  { value: 'purge', label: 'Purge' },
];

export const CHANGELOG_ENTITY_TYPE_OPTIONS = [
  { value: 'employee', label: 'HR profile' },
  { value: 'employee_compensation', label: 'Compensation' },
  { value: 'time_off_entry', label: 'Time off' },
  { value: 'employee_emergency_contacts', label: 'Emergency contacts' },
  { value: 'employee_children', label: 'Children' },
];

export function hasActiveChangelogFilters(filters) {
  if (!filters) return false;
  return Boolean(
    filters.search?.trim()
    || filters.action
    || filters.entity_type
    || filters.date_from
    || filters.date_to
  );
}
